import { DefaultMessages } from '@sheerid/jslib';

export const localesMessages: DefaultMessages['locales'] = {
    'en-US': 'English',
    ar: 'Arabic',
    bg: 'Bulgarian',
    'zh-HK': 'Chinese (Hong Kong)',
    zh: 'Chinese (Traditional)',
    hr: 'Croatian',
    cs: 'Czech',
    da: 'Danish',
    nl: 'Dutch',
    'en-GB': 'English (UK)',
    fi: 'Finnish',
    'fr-CA': 'French (Canadian)',
    fr: 'French',
    de: 'German',
    el: 'Greek',
    iw: 'Hebrew',
    hu: 'Hungarian',
    is: 'Icelandic',
    id: 'Indonesian',
    it: 'Italian',
    ja: 'Japanese',
    ko: 'Korean',
    lt: 'Lithuanian',
    ms: 'Malay',
    no: 'Norwegian',
    pl: 'Polish',
    'pt-BR': 'Portuguese (Brazil)',
    pt: 'Portuguese',
    ro: 'Romanian',
    ru: 'Russia',
    sr: 'Serbian',
    sk: 'Slovak',
    sl: 'Slovenian',
    es: 'Spanish',
    'es-ES': 'Spanish (Spain)',
    sv: 'Swedish',
    tr: 'Turkish',
};
